module.exports = __webpack_public_path__ + "img/ic_not_qualified.68ba3791.svg";